import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import SendFaxModal from 'components/practice/comms_center/fax/components/SendFaxModal/SendFaxModal';
import Button from 'components/shared/Buttons/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

import batchDelete from '../lib/handlers/batchDelete';

import DocumentPracticeShare from './DocumentPracticeShare';

function SelectedDocumentsActions({
  selectedRows,
  setSelectedRows,
  sendFaxModal,
  options,
  setSendFaxModal,
  gridApi
}) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const selectedItems = selectedRows.map((node) => node.data);

  const [faxData, setFaxData] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [shareWithPracticeModal, setShareWithPracticeModal] = useState({
    show: false,
    files: []
  });

  const clearSelection = () => {
    gridApi.deselectAll();
    setSelectedRows([]);
  };

  const [deleteConfirmation, setDeleteConfirmation] = useState();

  const sendFax = () => {
    setSendFaxModal({ show: true, files: selectedItems });
  };

  useEffect(() => {
    if (sendFaxModal && sendFaxModal?.files) {
      const createdFile = sendFaxModal?.files.map((item) => {
        return {
          name: item.name,
          file: item.file
        };
      });

      setFaxData({
        subject: ``,
        deliver_to: '',
        fax_numbers: [],
        files: [createdFile]
      });
    }
  }, [sendFaxModal]);

  const onBatchDelete = async () => {
    setDeleteLoading(true);
    await batchDelete({
      navigate,
      queryClient,
      selectedItems,
      setSelectedRows,
      setDeleteConfirmation
    });
    setDeleteLoading(false);
  };

  return (
    <>
      <Button
        onClick={() => setDeleteConfirmation(true)}
        size="small"
        icon="trash"
        type="link"
        className="!text-danger-500"
        iconColor="white"
        text="Delete"
        color="danger"
      />

      {options?.enableShareWithPractice && (
        <>
          <Button
            onClick={() => setShareWithPracticeModal({ show: true, files: selectedItems })}
            size="small"
            icon="share-filled"
            iconColor="white"
            text="Share with other locations"
            outlined
            color="primary"
          />

          {shareWithPracticeModal?.show && (
            <DocumentPracticeShare
              clearSelection={clearSelection}
              selectedFiles={shareWithPracticeModal?.files}
              handleOpen={shareWithPracticeModal?.show}
              handleClose={() => setShareWithPracticeModal({ show: false, files: [] })}
            />
          )}
        </>
      )}

      {options?.enableSendAsFax && (
        <>
          <Button
            onClick={sendFax}
            size="small"
            icon="send-filled"
            iconColor="white"
            text="Send as Fax"
            color="primary"
          />

          <SendFaxModal
            sendFaxModalVisible={sendFaxModal?.show}
            setSendFaxModalVisible={(show) => setSendFaxModal({ ...sendFaxModal, show })}
            faxData={faxData}
            documents={sendFaxModal?.files}
            customStyling={{ width: '1080px' }}
            clearSelection={clearSelection}
          />
        </>
      )}

      <Confirm
        variant="danger"
        secondaryBtnTxt="Keep"
        title="Delete documents"
        handleClose={() => setDeleteConfirmation(false)}
        icon="new-document-remove-red"
        primaryBtnTxt="Delete documents"
        handleOpen={deleteConfirmation}
        loading={deleteLoading}
        handleContinue={onBatchDelete}
        message="Are you sure you want to delete these documents?"
      />
    </>
  );
}

export default SelectedDocumentsActions;
